import styled from 'styled-components'
import { theme } from 'common/styles/theme'

export const StyledObjectData = styled.div`
  width: 100%;
  height: 430px;
`

export const StyledObjectType = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 26px;

  .MuiFormControl-root .MuiFormGroup-root {
    gap: 30px;
  }

  legend {
    font-size: 14px;
    color: #495057;
    margin-bottom: 3px;
  }

  span {
    display: flex;
    align-items: center;
    font-size: 14px;

    p {
      height: 18px;
      padding: 1px 4px 1px 4px;
      margin: 0;
      font-size: 12px;
      margin-left: 14px;
      background-color: #f6f6f6;
      border-radius: 2px;
      text-align: center;
      color: ${theme.colors.dark};
      font-weight: 600;
    }
  }
`

export const StyledContinueButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`
